import * as React from 'react';

class Confirm extends React.Component {
	constructor(props) {
		super(props);
	}
	__onOk() {
		const { onOk, _close } = this.props;
		onOk && onOk();
		_close && _close();
	}
	render() {
		const { title = '提&nbsp;&nbsp;示', content, okText, _close, showFooter } = this.props;

		return (
			<div className="w-modal-confirm">
				<div className="w-modal-confirm-hd"><em></em></div>
				<div className="w-modal-confirm-bd">
					<div className="w-modal-confirm-bd__hd">{title}</div>
					<div className="w-modal-confirm-bd__bd">{content}</div>
				</div>
				{showFooter &&
				<div className="w-modal-confirm-ft">
					<button className="w-button" onClick={this.__onOk.bind(this)}>{okText}</button>
				</div>
				}
			</div>
		);
	}
}

export default Confirm;